export default __webpack_public_path__ + "static/media/cape-verde.3f0076e8.png";